import htmx from "htmx.org/dist/htmx.esm.js";

/**
 * htmx, for the pages that ask to be enhanced by it.
 *
 * A bundle of its own, loaded by no page unless that page says it wants it. A
 * page asks through the `htmx` field on `UserPage`, and the shell keeps the
 * script tag only for one that set it. `/user/history/` was the first, and most
 * of `/user/` asks now. See `src/user/user-shell-htmx.ts`, and
 * `docs/user-features.md` for the table of which region each of them redraws.
 *
 * **The import is for its effect.** Evaluating the module builds htmx, which
 * reads the document once the parser has finished with it and wires up the
 * `data-hx-*` attributes it finds. The one assignment below is the whole of
 * this site's configuration.
 *
 * The ESM build is named outright because htmx 4.0.0 ships no `exports` map,
 * and `types/htmx-esm.d.ts` has the whole of why.
 *
 * **`data-hx-*` and never `hx-*`.** htmx 4 reads both, the second prefix being
 * its `prefix` setting and `data-hx-` being what that setting is born holding.
 * The `data-` form is an attribute HTML defines, and it puts htmx's markup in
 * the same space as the `data-cb-*` this site already writes.
 *
 * **A page enhanced here works without this file.** Every control carries an
 * `action` and a `method` of its own, and every enhanced link carries the
 * `href` it was already going to. A reader whose script never arrives posts a
 * form or follows a link and is sent a page. Each route writes both answers,
 * and one function draws the markup for each. `src/user/htmx-exchange.ts` is
 * that arrangement and `src/user/history-page.ts` the first route to keep it.
 *
 * **What this file does not do is bind anything of this site's.** The regions
 * htmx replaces on `/user/ci/` and `/user/liju/` hold save controls bound by
 * the site bundle, and rebinding them is that bundle's own job, hung off an
 * ordinary bubbling event so the two bundles need not meet. See
 * `src/site/htmx-rebinding.ts`.
 */

/**
 * Back and forward fetch the page again.
 *
 * htmx restores a history entry by asking the address for a fresh copy and
 * swapping the reply into `<body>`. The replies here are whole documents, so
 * that swap would put a second `<head>` inside the page. `"reload"` leaves the
 * address bookkeeping switched on and gives the restore itself to the browser.
 *
 * The core of htmx 4 keeps no copy of a page anywhere. htmx 2 held one in
 * `localStorage`, and a `/user/` page is served `no-store, private` for reasons
 * that a browser-side copy would undo. The setting to watch, on any upgrade
 * that adds one, is `hx-history-cache`.
 */
htmx.config.history = "reload";

/**
 * A failed request leaves the page as it was.
 *
 * htmx 4 swaps whatever comes back unless the status is listed here, where
 * htmx 2 swapped 2xx alone. Every failure this site answers with is JSON, and
 * the default put `{"error":"Sign in to use history"}` where a reader's lookups
 * had been. The two entries above the patterns are htmx's own and the patterns
 * are what restores the older behaviour.
 *
 * A route with something to say about a failure says it with a header. The
 * history page answers an expired session with `HX-Redirect` to sign-in, which
 * htmx acts on before it reaches any of this. See `src/user/htmx-exchange.ts`.
 *
 * The cast is htmx 4.0.0 typing the setting as `number[]` while
 * `#handleStatusCodes` builds `"401"`, `"40x"` and `"4xx"` from the status and
 * looks each up in this list. The patterns are what the code reads and the
 * type is narrower than the code. Drop the cast when the package's own
 * declaration catches up.
 */
htmx.config.noSwap = [204, 304, "4xx", "5xx"] as unknown as number[];
